module.exports = __webpack_public_path__ + "static/reel-gen-39b21db880ff974a36bebe1a0655d7cc.mp4";